<div class="card">
    <app-header titulo="Notas Fiscais" descricao="Dados das baixas de notas fical"></app-header>

    <div class="flex flex-row flex-wrap">
        <div class="flex ml-1 xl:mt-1">
            <p-multiSelect
            appendTo="body"
            [options]="instancias"
            [filter]="true"
            [style]="{'width':'200px'}"
            optionValue="id"
            optionLabel="nome"
            [(ngModel)]="instanciaSelecionada"
            dataKey="id" inputId="id"
            placeholder="Instância"
            emptyMessage="Nenhuma instância"
            (onChange)="getNotaFiscals()">

           </p-multiSelect>
        </div>
        <div class="flex ml-1 xl:mt-1">
            <p-calendar
          [(ngModel)]="rangeDates"
          selectionMode="range"
          dateFormat="dd/mm/yy"
          [readonlyInput]="true"
          placeholder="Selecione o período"
          (onClose)="getNotaFiscals()"/>
        </div>

        <div class="flex ml-1 xl:mt-1">
            <button pButton pRipple icon="pi pi-arrow-down-right" (click)="sincronizar()" label="Buscar PIMS"
            [loading]="loadingSincronizar" [disabled]="loading"></button>
        </div>
        <div class="flex ml-1 xl:mt-1">
            <button pButton pRipple icon="pi pi-arrow-up-right" (click)="integrar()" label="Enviar ERP"
            [loading]="loadingInteg" [disabled]="loading"></button>
        </div>
        <div class="flex ml-1 xl:mt-1">
            <button pButton pRipple icon="pi pi-arrow-up-right" (click)="integrarTaxa()" label="Enviar Taxas ERP"
            [loading]="loadingInteg" [disabled]="loading"></button>
        </div>
        <div class="flex ml-1 xl:mt-1">
            <p-splitButton label="Reversão" icon="pi pi-undo" [model]="itensReversao" />
        </div>
        <div class="flex ml-1 xl:mt-1">
            <button pButton pRipple icon="pi pi-file-excel" (click)="exportar()" label="Exportar"
            [loading]="loadingInteg" [disabled]="loading"></button>
        </div>
    </div>

    <p-table [value]="notaFiscals" dataKey="idNf" #dt [loading]="loading" [globalFilterFields]="['deProcesso','instancia', 'noNfPims', 'cdFornecErp','vlLiquido','valorTaxa','fazenda']"
        styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines mt-3" [rowsPerPageOptions]="[20, 50, 100,500,1000]"
        [paginator]="true" [rows]="20" [showCurrentPageReport]="true"
        currentPageReportTemplate="{{notasSelecionadas.length}} registros selecionados | Mostrando de {first} até {last} de {totalRecords} registros" [scrollable]="true"
        scrollHeight="40.5rem" [(selection)]="notasSelecionadas">
        <ng-template pTemplate="caption">
            <div class="flex">

                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')"
                        placeholder="Pesquisar" />
                </span>
                <button class="ml-3" pButton pRipple icon="pi pi-refresh" (click)="getNotaFiscals()"></button>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
                <th>Processo
                    <p-columnFilter field="deProcesso" matchMode="in" display="menu" [showApplyButton]="false" [showClearButton]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">

                        <ng-template pTemplate="filter" let-value let-filter="filterCallback" >
                            <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="processos" placeholder="Todos" [filter]="true"  optionValue="id" (onChange)="filter($event.value)" optionLabel="nome">

                                <ng-template let-option pTemplate="item">
                                    <div class="inline-block vertical-align-middle">
                                        <span class="ml-1 mt-1">{{ option.nome }}</span>
                                    </div>
                                </ng-template>

                            </p-multiSelect>
                        </ng-template>

                        <ng-template pTemplate="clearfiltericon">

                        </ng-template>
                    </p-columnFilter>
                </th>
              <th pSortableColumn="instancia">Instância
                <p-sortIcon field="instancia"/>
              </th>
                <th>Data Competência</th>
              <th pSortableColumn="noNfPims">Número Nota Fiscal (Pims)
                <p-sortIcon field="noNfPims"/>
              </th>
                <th>Série Nota Fiscal (Pims)</th>
                <th>Data Lançamento</th>
              <th pSortableColumn="cdFornecErp">Código Fornecedor (ERP)
                <p-sortIcon field="cdFornecErp"/>
                <p-columnFilter field="cdFornecErp" matchMode="in" display="menu" [showApplyButton]="false"
                                [showClearButton]="false" [showMatchModes]="false" [showOperator]="false"
                                [showAddButton]="false" style="width: 5rem;">

                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="fornecedores"
                                   placeholder="Todos" [filter]="true" optionValue="id" (onChange)="filter($event.value)"
                                   optionLabel="nome" emptyMessage="Sem registros">

                      <ng-template let-option pTemplate="item">
                        <span class="pr-8">{{ option.nome }}</span>
                      </ng-template>

                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th pSortableColumn="fazenda">Fazenda
                <p-sortIcon field="fazenda"/>
                <p-columnFilter field="fazenda" matchMode="in" display="menu" [showApplyButton]="false"
                                [showClearButton]="false" [showMatchModes]="false" [showOperator]="false"
                                [showAddButton]="false" style="width: 5rem;">

                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="fazendas"
                                   placeholder="Todos" [filter]="true" optionValue="id" (onChange)="filter($event.value)"
                                   optionLabel="nome" emptyMessage="Sem registros">

                      <ng-template let-option pTemplate="item">
                        <span class="pr-8">{{ option.nome }}</span>
                      </ng-template>

                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </th>
                <th>Valor Líquido</th>
                <th>Valor Bruto</th>
                <th>Número Documento (ERP)</th>
              <th pSortableColumn="fgStatusInteg">Integrado
                <p-sortIcon field="fgStatusInteg"/>
                <p-columnFilter field="fgStatusInteg" matchMode="in" display="menu" [showApplyButton]="false" [showClearButton]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">

                  <ng-template pTemplate="filter" let-value let-filter="filterCallback" >
                    <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="status" placeholder="Todos" [filter]="true"  optionValue="value" (onChange)="filter($event.value)" optionLabel="name">

                      <ng-template let-option pTemplate="item">
                        <div class="inline-block vertical-align-middle">
                          <span class="ml-1 mt-1">{{ option.name }}</span>
                        </div>
                      </ng-template>

                    </p-multiSelect>
                  </ng-template>

                  <ng-template pTemplate="clearfiltericon">

                  </ng-template>
                </p-columnFilter>
              </th>
                <th>Mensagem</th>
                <th>Número Nota Fiscal (ERP)</th>
                <th>Série Nota Fiscal (ERP)</th>
              <th pSortableColumn="descTaxa">Taxa
                <p-sortIcon field="descTaxa"/>
                <p-columnFilter field="descTaxa" matchMode="in" display="menu" [showApplyButton]="false"
                                [showClearButton]="false" [showMatchModes]="false" [showOperator]="false"
                                [showAddButton]="false" style="width: 5rem;">

                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="taxas"
                                   placeholder="Todos" [filter]="true" optionValue="id" (onChange)="filter($event.value)"
                                   optionLabel="nome" emptyMessage="Sem registros">

                      <ng-template let-option pTemplate="item">
                        <span class="pr-8">{{ option.nome }}</span>
                      </ng-template>

                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </th>
                <th>Valor Taxa</th>
              <th pSortableColumn="statusIntegTaxa">Status Taxa
                <p-sortIcon field="statusIntegTaxa"/>

                <p-columnFilter field="statusIntegTaxa" matchMode="in" display="menu" [showApplyButton]="false" [showClearButton]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">

                  <ng-template pTemplate="filter" let-value let-filter="filterCallback" >
                    <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="statusTaxa" placeholder="Todos" [filter]="true"  optionValue="value" (onChange)="filter($event.value)" optionLabel="name">

                      <ng-template let-option pTemplate="item">
                        <div class="inline-block vertical-align-middle">
                          <span class="ml-1 mt-1">{{ option.name }}</span>
                        </div>
                      </ng-template>

                    </p-multiSelect>
                  </ng-template>

                  <ng-template pTemplate="clearfiltericon">

                  </ng-template>
                </p-columnFilter>
              </th>
                <th>Mensagem Taxa</th>
                <th>Nº Doc Taxa (ERP)</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-notaFiscal>
            <tr>
                <td><p-tableCheckbox [value]="notaFiscal" /></td>
                <td>{{ notaFiscal.deProcesso }}</td>
                <td>{{ notaFiscal.instancia }}</td>
                <td>{{ notaFiscal.dtCompetencia | date:'dd/MM/yyyy' }}</td>
                <td>{{ notaFiscal.noNfPims }}</td>
                <td>{{ notaFiscal.noSeriePims }}</td>
                <td>{{ notaFiscal.dtDancto | date:'dd/MM/yyyy' }}</td>
                <td>{{ notaFiscal.cdFornecErp }}</td>
                <td>{{ notaFiscal.fazenda }} </td>
                <td>{{ notaFiscal.vlLiquido.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2})  || 0 }}</td>
                <td>{{ notaFiscal.vlBruto.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2})  || 0 }}</td>
                <td>{{ notaFiscal.noDocErp }}</td>
                <td><app-tag-status [status]="notaFiscal.fgStatusInteg" ></app-tag-status></td>
                <td>{{ notaFiscal.deMensagemInteg }}</td>
                <td>{{ notaFiscal.noNfErp }}</td>
                <td>{{ notaFiscal.noSerieErp }}</td>
                <td>{{ notaFiscal.descTaxa }}</td>
                <td>{{ notaFiscal.valorTaxa.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2})  || 0  }}</td>
              <td>
                <app-tag-status *ngIf="notaFiscal.statusIntegTaxa" [status]="notaFiscal.statusIntegTaxa"></app-tag-status>
              </td>
                <td>{{ notaFiscal.deMensagemIntegTaxa }}</td>
                <td>{{ notaFiscal.noDocErpTaxa }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <td colspan="21">Nenhum registro encontrado</td>
        </ng-template>
    </p-table>
</div>

<p-confirmDialog header="Confirmation" width="425"></p-confirmDialog>
